import { BASE_URL } from "@/services/api";
import { METHOD, request } from "@/utils/request";

let ROOM_LIST = `${BASE_URL}/room/list`;
let ROOM_DETAIL = `${BASE_URL}/room/detail`;
let UPDATE_CHECK_CODE = `${BASE_URL}/room/updateCheckCode`;
let GETROOM_BY_CHECK = `${BASE_URL}/room/getRoomByCheck`;
let SAVE_ROOM = `${BASE_URL}/room/saveRoom`;
let ROOM_LIST_BY_CREATED = `${BASE_URL}/room/roomListByCreateUser`;
let ROOM_DELETE = `${BASE_URL}/room/delete`;
let ROOM_SAVE_LOG = `${BASE_URL}/room/saveLog`;
let GET_YOTEI_DETAIL = `${BASE_URL}/room/yoteidetail`;
let SAVE_YOTEI = `${BASE_URL}/room/saveyotei`;
let USER_YOTEI = `${BASE_URL}/room/useryotei`;
let YOTEI_DELETE = `${BASE_URL}/room/yoteidelete`;
let GET_AVALID_ROOM = `${BASE_URL}/room/getAvalidRoom`;
let GET_ROOMS = `${BASE_URL}/room/getRooms`;
let GET_SCHEDULES = `${BASE_URL}/room/getSchedules`;
let GET_DOCTORS_BY_ROOM = `${BASE_URL}/room/getDoctorsByRoom`;
let ROOM_YOTEI_CHECK = `${BASE_URL}/room/roomYoteiCheck`;



export async function GetRoomList(params) {
  return request(ROOM_LIST, METHOD.POST, params);
}

export async function GetRoomDetail(room_id) {
  return request(ROOM_DETAIL, METHOD.POST, { room_id: room_id });
}
export async function UpdateCheckCode(id) {
  return request(UPDATE_CHECK_CODE, METHOD.POST, { id: id });
}

export async function GetRoomByCheck(check_code) {
  return request(GETROOM_BY_CHECK, METHOD.POST, { check_code: check_code });
}

export async function SaveRoom(params) {
  return request(SAVE_ROOM, METHOD.POST, params);
}

export async function GetRoomListByCreated() {
  return request(ROOM_LIST_BY_CREATED, METHOD.GET);
}

export async function DeleteRoom(params) {
  return request(ROOM_DELETE, METHOD.POST, params);
}

export async function SaveRoomLog(params) {
  return request(ROOM_SAVE_LOG, METHOD.POST, params);
}

export async function GetYoteiDetail(params) {
  return request(GET_YOTEI_DETAIL, METHOD.POST, params);
}

export async function SaveYotei(params) {
  return request(SAVE_YOTEI, METHOD.POST, params);
}

export async function GetYoteiById(params) {
  return request(USER_YOTEI, METHOD.POST, params);
}

export async function YoteiDelete(params) {
  return request(YOTEI_DELETE, METHOD.POST, params);
}

export async function GetAvalidRoom(params) {
  return request(GET_AVALID_ROOM, METHOD.POST, params);
}

export async function GetRooms() {
  return request(GET_ROOMS, METHOD.POST);
}

export async function GetScheduls(params) {
  return request(GET_SCHEDULES, METHOD.POST, params);
}

export async function GetDoctorsByRoom(params) {
  return request(GET_DOCTORS_BY_ROOM, METHOD.POST, params);
}

export async function RoomYoteiCheck(params) {
  return request(ROOM_YOTEI_CHECK, METHOD.POST, params);
}

export default {
  GetRoomList,
};
